import React from 'react';

/**
 * Shared dashboard panel chrome: dark card, hairline border, hover accent, top highlight.
 */
export default function DashboardPanel({
  title,
  subtitle = null,
  children,
  className = '',
  action = null,
  bodyClassName = '',
}) {
  return (
    <div
      className={[
        'group relative h-full overflow-hidden rounded-lg border border-dark-border',
        'bg-dark-card/90 p-3 transition-colors duration-200 hover:border-primary/40',
        'animate-fade-in',
        className,
      ].join(' ')}
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/[0.08] to-transparent"
        aria-hidden
      />
      {(title || action) && (
        <div className="mb-2 flex items-start justify-between gap-3">
          {title ? (
            <div className="min-w-0">
              <h2 className="text-sm font-semibold text-dark-text sm:text-base">{title}</h2>
              {subtitle ? (
                <p className="mt-0.5 text-xs leading-snug text-dark-text-secondary">{subtitle}</p>
              ) : null}
            </div>
          ) : (
            <span />
          )}
          {action}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}
